<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { useStepperStore } from '../../stores/stepper.store.js';
import { useRemoteProducts } from '../services/use.remote-products.js';
import { useFormSubmitted } from '../services/use.form-submitted.js';
import { useWrapper } from '../services/use.wrapper.js';
import Card from './components/Card.vue';
import CategoryLabel from './components/CategoryLabel.vue';
import ContinueWithoutCard from './components/ContinueWithoutCard.vue';
import { useSelectedProduct } from '../services/use.selected-product.js';
import { useSelectedCategory } from './services/use.selected-category.js';
import { useSettings } from './services/use.settings.js';
import { useOtherStepperBlock, useStepperBlock } from '../services/use.stepper-block.js';
import { useStore } from './services/use.store.js';

const { settings, refreshSettings } = useSettings();
const { selectedProduct: selectedCard, selectProduct: selectCard, clearProductSelection: clearCardSelection } = useSelectedProduct();
const { loadProducts: loadCards, products: cards } = useRemoteProducts(selectCard);
const { parentStepId } = useWrapper('pick-a-card-wrapper');
const { isFormSubmitted } = useFormSubmitted(parentStepId);
const { selectCategory, selectedCategory } = useSelectedCategory(loadCards);
const { disableBlock: disableMessageBlock, enableBlock: enableMessageBlock } = useOtherStepperBlock('pick-a-card--message');

const skippedCard = ref(false);

useStepperBlock('pick-a-card', async () => {
  if (skippedCard.value) {
    return true;
  }

  return !!selectedCard.value;
});
useStore(selectedCard);

onMounted(() => {
  refreshSettings();
});

function skipCardSelection() {
  disableMessageBlock();
  clearCardSelection();
  skippedCard.value = true;
  useStepperStore().getState().steps.goToNextStep();
}
</script>

<template>
  <section ref="wrapper" class="pick-a-card__app" :class="{ touched: isFormSubmitted }">
    <header class="pick-a-card-categories">
      <category-label
        v-for="collection in settings?.collection_groups"
        :is-active="selectedCategory === collection.label"
        :key="collection.slug"
        :label="collection.label"
        :products="collection.products"
        @selected="() => selectCategory(collection.label, collection.products)"
      />
    </header>

    <div class="configurator-pick-a-card_options">
      <Card
        v-for="card in cards"
        :key="card.id"
        :card="card"
        :is-active="selectedCard === card.variants.at(0)?.id"
        @card-picked="
          () => {
            skippedCard = false;
            enableMessageBlock();
            selectCard(card);
          }
        "
      />
    </div>

    <continue-without-card
      v-if="settings?.show_no_card"
      :label="settings?.no_card_button_label ?? ''"
      @skip-card-selection="skipCardSelection"
    />
  </section>
</template>
